// common/ColorPickerHousestyle.jsx
import useSettings from "../../hooks/Settings";

const ColorPickerHousestyle = ({ item, onChange, layoutitem, mappingKey = "IndicatorColor" }) => {
  const { PrimaryColor, SecundairyColor, TertairyColor } = useSettings();

  const colorOptions = {
    primary: PrimaryColor,
    secundairy: SecundairyColor,
    tertiary: TertairyColor,
  };

  // Pick the right mapping (IndicatorColor vs GraphColor) and resolve selected color
  const mapping = layoutitem?.[mappingKey] || {};
  const selectedColor = mapping?.[item?.ID] ?? item?.Color ?? "#000000";

  return (
    <div>
      {Object.entries(colorOptions).map(([key, color]) => (
        <div key={key} className="color-picker-select-color-container">
          <input
            type="radio"
            id='color-picker-housestyle-input'
            name={`color-${item.ID}`}
            value={color}
            checked={selectedColor === color}
            data-outputid={item.ID}
            data-docid={item.docid}
            data-id={item.ID}
            onChange={onChange}
          />
          <div className="color-picker-color-container" style={{ backgroundColor: color }} />
        </div>
      ))}
    </div>
  );
};

export default ColorPickerHousestyle;


